import {Component, OnInit} from '@angular/core';

import {CompanyPhotoResponseModel} from "../../../model/jubili/company-manage/company-photo-model";
import {CompanyManageService} from "../../../service/api/jubili/company-manage.service";

@Component({
  selector: 'app-upload-image-import-item',
  templateUrl: './upload-image-import-item.component.html',
  styleUrls: ['./upload-image-import-item.component.scss']
})
export class UploadImageImportItemComponent implements OnInit {

  companyList = new CompanyPhotoResponseModel();
  maxPage = 10;
  currentPage = 1;
  textSearch = "";
  textSearchOld = ""
  searchTimer: any

  constructor(
    private companyManageService: CompanyManageService) {
  }

  ngOnInit() {
    this.getCompanyList();
  }

  getCompanyList(): void {
    this.companyManageService.getCompanyPhoto(this.textSearch, this.currentPage, this.maxPage).subscribe(response => {
      if (response != null) {
        this.companyList = response;
      } else {
        this.companyList.companyList = [];
        this.companyList.count = 0;
      }
    });
  }

  eventSearch(): void {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.searchCompany(), 500);
  }

  searchCompany(): void {
    if (this.textSearch != this.textSearchOld) {
      this.textSearchOld = this.textSearch;
      this.currentPage = 1;
      this.getCompanyList();
    }
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.getCompanyList();
  }
}
